/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Teachingsubjects1Inputs */

const en__field_teachingsubjects1 = /** @type {(inputs: _Field_Teachingsubjects1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teaching Subjects`)
};

const de__field_teachingsubjects1 = /** @type {(inputs: _Field_Teachingsubjects1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schulfächer`)
};

/**
* | output |
* | --- |
* | "Teaching Subjects" |
*
* @param {_Field_Teachingsubjects1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_teachingsubjects1 = /** @type {((inputs?: _Field_Teachingsubjects1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Teachingsubjects1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_teachingsubjects1(inputs)
	return de__field_teachingsubjects1(inputs)
});
export { _field_teachingsubjects1 as "_field_teachingSubjects" }